import React from 'react';
import { ArrowUpRight, Mail, MapPin } from 'lucide-react';
import { profileData } from '../../data/profileData';
import { Button, Card, GitHubIcon, Icon, LinkedInIcon } from '../ui';
import './Contact.css';

const Contact: React.FC = () => {
  const { basicInfo } = profileData;
  const channels = [
    {
      label: 'Email',
      detail: basicInfo.email,
      href: `mailto:${basicInfo.email}`,
      icon: <Icon icon={Mail} size={22} />,
      external: false,
    },
    {
      label: 'LinkedIn',
      detail: 'Connect and follow new articles',
      href: basicInfo.linkedIn,
      icon: <LinkedInIcon size={22} />,
      external: true,
    },
    {
      label: 'GitHub',
      detail: 'Code and experiments',
      href: basicInfo.github,
      icon: <GitHubIcon size={22} />,
      external: true,
    },
  ];

  return (
    <section className="ui-section contact" id="contact" aria-labelledby="contact-heading">
      <div className="ui-section__inner">
        <header className="ui-section-header">
          <p className="ui-section-header__eyebrow">Let's talk</p>
          <h2 id="contact-heading" className="ui-section-header__title">
            Contact
          </h2>
          <p className="ui-section-header__intro">
            Questions about an article, or an idea worth exploring together? I'd be glad to hear from you.
          </p>
        </header>

        <ul className="contact__channels">
          {channels.map((channel) => (
            <Card as="li" interactive key={channel.label} className="contact__channel">
              <a
                href={channel.href}
                className="contact__link"
                {...(channel.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              >
                <span className="contact__icon" aria-hidden="true">
                  {channel.icon}
                </span>
                <span className="contact__text">
                  <span className="contact__label">{channel.label}</span>
                  <span className="contact__detail">{channel.detail}</span>
                </span>
                <Icon icon={ArrowUpRight} size={18} className="contact__arrow" />
              </a>
            </Card>
          ))}
        </ul>

        <div className="contact__footer">
          <p className="contact__location">
            <Icon icon={MapPin} size={16} />
            Based in {basicInfo.location}
          </p>
          <Button href={`mailto:${basicInfo.email}`} icon={<Icon icon={Mail} size={18} />}>
            Email me
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Contact;
